import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Model from "../Model";
import tw from "tailwind-styled-components";
import {
    CancelBtn,
    InputGroup,
    Label,
    Note,
    SideCancelBtn,
    SubmitBtn,
} from "../Styles/InputStyles";
import Loading from "../Loading";
import Config from "../../Config";

const validationSchema = Yup.object({
    roomNumber: Yup.string()
        .min(1, "Room number must be at least 1 character")
        .max(5, "Room number must be at most 5 characters")
        .required("Room number is required"),
});

const EditRoom = ({
    setEditModel,
    selectedData,
    editRoomNumberLoading,
    editRoomNumberMutate,
    activateRoomLoading,
    activateRoomMutate,
    deactivateRoomLoading,
    deactivateRoomMutate,
    setIsExtraBed,
    setSelectedData,
}) => {
    const initialValues = {
        roomNumber: selectedData?.roomNum || "",
        id: selectedData?.id,
    };

    const handleEditSubmit = (values) => {
        editRoomNumberMutate({
            roomId: selectedData.id,
            newRoomNum: values.roomNumber,
        });
    };

    const handleRoomStatus = () => {
        if (selectedData.status === Config.ROOM_STATUS.INACTIVE) {
            activateRoomMutate({
                roomId: selectedData.id
            });
        } else if (selectedData.status === Config.ROOM_STATUS.VACANT) {
            deactivateRoomMutate({
                roomId: selectedData.id
            });;
        }
    };
    const isActivateRoom = selectedData.status === Config.ROOM_STATUS.INACTIVE;
    const buttonText = isActivateRoom ? "Activate Room" : "Deactivate Room";
    const isLoading = isActivateRoom ? activateRoomLoading : deactivateRoomLoading;
    const loadingText = isActivateRoom ? "Activating..." : "Deactivating...";

    return (
        <Model
            width={"w-full max-w-md"}
            setOpenModel={setEditModel}
            title="Edit Room"
        >
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleEditSubmit}
            >
                {() => (
                    <Form>
                        <InputGroup>
                            <div className="flex justify-between">
                                <Label>Room No.</Label>
                                {selectedData?.beds?.length < 7 && selectedData.status !== Config.ROOM_STATUS.INACTIVE && selectedData.status !== Config.ROOM_STATUS.VACANT &&
                                    <button className="text-primary-color underline" type="button" onClick={() => {
                                        setIsExtraBed(true);
                                        setEditModel(false);
                                    }}>Add Extra Bed</button>}
                            </div>
                            <Field
                                type="text"
                                name="roomNumber"
                                className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="Enter Room No."
                            />
                            <ErrorMessage
                                name="roomNumber"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                            />
                        </InputGroup>

                        <div className="w-full flex justify-between space-x-6 my-4">
                            <SideCancelBtn onClick={() => setEditModel(false)}>
                                Cancel
                            </SideCancelBtn>
                            <SubmitBtn type="submit" disabled={editRoomNumberLoading} className="border border-primary-color bg-white text-primary-color hover:bg-primary-color hover:text-white">
                                {" "}
                                {editRoomNumberLoading ? "Editing..." : "Edit"}
                            </SubmitBtn>
                        </div>

                        <DeactivateRoomBtn
                            type="button"
                            onClick={handleRoomStatus}
                            disabled={selectedData.status !== Config.ROOM_STATUS.VACANT && selectedData.status !== Config.ROOM_STATUS.INACTIVE}
                            className={`w-full border items-center mb-2 h-12 rounded-lg 
                                ${isActivateRoom ? "border-green-500 text-green-500" : "border-red-500 text-red-500"}
                                disabled:opacity-50 disabled:cursor-not-allowed
                            `}
                        >
                            {isLoading ? (
                                loadingText
                            ) : (
                                buttonText
                            )}
                        </DeactivateRoomBtn>
                        {/* <span className="text-center items-center flex justify-center text-sm text-gray-400">A room must be vacant in order to be deactivate.</span> */}
                        <Note>A room must be vacant in order to be deactivate.</Note>
                    </Form>
                )}
            </Formik>
        </Model>
    );
};

const SubTitle = tw.p`text-sm md:text-base text-left mb-6 text-gray-700 text-pretty pt-2`;
const DeactivateRoomBtn = tw.button`w-full border border-red-500 items-center mb-2 text-red-500 h-12 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed`;

export default EditRoom;